import classNames from "classnames";
import React from "react";
import { Fa } from "../../atoms/Icons/Fa";
import { Text } from "../../atoms/Text/Text";
import { FriendTabs } from "../../services/Friend/FriendService";
import styles from "./FriendContainer.css";

type RenderHeaderTabsProps = {
  renderTab: (
    tabName: string,
    label: string,
    tabKey: FriendTabs,
    onClick: any
  ) => JSX.Element;
  onTabSelect: (tabId) => void;
  friendCount: number;
  onSendInvite: () => void;
  showChallengeTab: boolean;
};

export class RenderHeaderTabs extends React.Component<RenderHeaderTabsProps> {
  render() {
    const {
      renderTab,
      onTabSelect,
      friendCount,
      onSendInvite,
      showChallengeTab,
    } = this.props;

    return (
      <div className={styles.thead}>
        <div className={styles.thead_tr}>
          <div className={styles.thead_th}>
            <TabsList role="tablist" className={styles.thead_tablist}>
              <div className={styles.counter}>
                <Text className={styles.openButton}>View by</Text>
              </div>
              <div className={styles.buttonFirstBlock}>
                {renderTab(
                  "Game",
                  "leaderboard Private Friends Network Game tab",
                  FriendTabs.OrderByDate,
                  () => onTabSelect(FriendTabs.OrderByDate)
                )}

                {renderTab(
                  "Friend",
                  "leaderboard Private Friends Network Friend tab",
                  FriendTabs.OrderByFriend,
                  () => onTabSelect(FriendTabs.OrderByFriend)
                )}

                {showChallengeTab &&
                  renderTab(
                    "Challenges",
                    "leaderboard Private Friends Network Challenges tab",
                    FriendTabs.ViewSendChallenges,
                    () => onTabSelect(FriendTabs.ViewSendChallenges)
                  )}
              </div>
            </TabsList>

            <TabsList role="tablist" className={styles.thead_tablist}>
              <div
                className={classNames([styles.friendCounter, styles.counter])}
              >
                <Text bold={true} size="xxl" style={{ lineHeight: "1em" }}>
                  {friendCount}
                </Text>
                <Text style={{ padding: "0px 8px" }}>Friends</Text>
              </div>

              <div className={styles.buttonSecondBlock}>
                {renderTab(
                  "+ Invite",
                  "Invite Private Friends Network Friend tab",
                  FriendTabs.Invite,
                  () => onSendInvite()
                )}

                {renderTab(
                  "Edit",
                  "Private Private Friends Network Edit tab",
                  FriendTabs.GlobalFriend,
                  () => onTabSelect(FriendTabs.GlobalFriend)
                )}
              </div>
            </TabsList>
          </div>
        </div>
      </div>
    );
  }
}

const TabsList = (props: any) => <div className={styles.tabsList} {...props} />;
